import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./styles/index.css";
import { mask } from "vue-the-mask";

createApp(App).directive("mask", mask).use(store).use(router).mount("#app");
